import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { certificateTemplateOne } from "../../store/certificates/actions";
export var GetOneCertTemplate = function (trigger, certificateId) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingOneCertTemplate: state.Certificates.loadingOneCertTemplate,
        responseOneCertTemplate: state.Certificates.responseOneCertTemplate,
        errorOneCertTemplate: state.Certificates.errorOneCertTemplate,
    }); }), loadingOneCertTemplate = _a.loadingOneCertTemplate, responseOneCertTemplate = _a.responseOneCertTemplate, errorOneCertTemplate = _a.errorOneCertTemplate;
    useEffect(function () {
        if (trigger) {
            dispatch(certificateTemplateOne({
                id: certificateId,
            }));
        }
    }, [trigger, certificateId]);
    return {
        loadingOneCertTemplate: loadingOneCertTemplate,
        responseOneCertTemplate: responseOneCertTemplate,
        errorOneCertTemplate: errorOneCertTemplate,
    };
};
